import { defineStore } from 'pinia'

export const useConfigStore = defineStore('config', {
  state: () => {
    return { imnar: true }
  },
  persist: true,
  actions: {
    hideImnar() {
      this.imnar = false
    },
  },
})